/**
 * Progress theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/progress.ts
 */
import { progressAnatomy as parts } from '@chakra-ui/anatomy';
export const Progress = {
    parts: parts.keys,
    baseStyle() {
        return {
            track: {
                bg: 'brand.gray-scale-border-20',
            },
            filledTrack: {
                bg: 'brand.secondary-sky-blue',
            },
        };
    },
    variants: {},
    sizes: {
        xxs: {
            track: {
                h: '2px',
            },
        },
    },
    defaultProps: {},
};
